export const ADD_ITEM_ACTION_NAME = "addItem";
export const ADD_ITEM_LABEL = "Add Item";
export const ADD_MULTIPLE_ITEM_ACTION_NAME = "addMultiple";
export const ADD_MULTIPLE_LABEL = "Add Multiple";
export const IMPORT_ITEMS_ACTION_NAME = "importItems";
export const IMPORT_ITEMS_LABEL = "Import Items";

export const MAX_NUM_ITEMS_ERROR =
  "It is not possible to add more than 500 items at a time. The first 500 items have been already created, please keep adding more if needed";
